export const DEFAULT_ROW_HEIGHT = 40

export const DEFAULT_COLUMN_SIZE = 200

export const DEFAULT_COLUMN_MIN_SIZE = 20

export const DEFAULT_COLUMN_MAX_SIZE = 600
